import { render, staticRenderFns } from "./NewUpdateModal.vue?vue&type=template&id=6e01f5d2&scoped=true"
import script from "./NewUpdateModal.vue?vue&type=script&lang=js"
export * from "./NewUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./NewUpdateModal.vue?vue&type=style&index=0&id=6e01f5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e01f5d2",
  null
  
)

export default component.exports